import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const industries = [
  {
    id: 'consumer-goods',
    name: 'Consumer Goods & Electronics',
    description: 'High-velocity storage solutions for fast-moving consumer goods and electronics.',
    image: 'https://images.unsplash.com/photo-1768796373360-95d80c5830fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxjb252ZXlvciUyMGJlbHQlMjBwYWNrYWdlcyUyMGRpc3RyaWJ1dGlvbiUyMGNlbnRlcnxlbnwwfHx8fDE3NzE4MjI5NTd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'automotive',
    name: 'Automotive',
    description: 'Specialized storage for automotive parts, components, and assemblies.',
    image: 'https://images.unsplash.com/photo-1469289759076-d1484757abc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhdXRvbW90aXZlJTIwcGFydHMlMjB3YXJlaG91c2UlMjBzdG9yYWdlJTIwaW5kdXN0cnl8ZW58MHx8fHwxNzcxODIyOTQyfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'food-beverage',
    name: 'Food & Beverages',
    description: 'Temperature-controlled and FIFO-compliant storage for food products.',
    image: 'https://images.pexels.com/photos/4170172/pexels-photo-4170172.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: '3pl-logistics',
    name: '3PL, Logistics & Warehousing',
    description: 'Flexible infrastructure for multi-client logistics operations.',
    image: 'https://images.unsplash.com/photo-1720036236694-d0a231c52563?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwcmFja2luZyUyMHN5c3RlbSUyMHN0ZWVsJTIwbWV6emFuaW5lJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3NzE4MjI5NDB8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'ecommerce',
    name: 'E & Q Commerce',
    description: 'High-throughput fulfillment solutions for e-commerce and quick commerce.',
    image: 'https://images.unsplash.com/photo-1768796373360-95d80c5830fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxjb252ZXlvciUyMGJlbHQlMjBwYWNrYWdlcyUyMGRpc3RyaWJ1dGlvbiUyMGNlbnRlcnxlbnwwfHx8fDE3NzE4MjI5NTd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'pharmaceuticals',
    name: 'Pharmaceuticals',
    description: 'Compliant storage solutions for pharmaceutical products and medical supplies.',
    image: 'https://images.unsplash.com/photo-1694885156873-6a0823e14848?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwaGFybWFjZXV0aWNhbCUyMGNvbGQlMjBzdG9yYWdlJTIwd2FyZWhvdXNlJTIwc2hlbHZlc3xlbnwwfHx8fDE3NzE4MjI5NDF8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'semiconductors',
    name: 'Semi Conductors',
    description: 'Precision storage for sensitive semiconductor components and equipment.',
    image: 'https://images.unsplash.com/photo-1720036236697-018370867320?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhdXRvbWF0ZWQlMjB3YXJlaG91c2UlMjBpbnRlcmlvciUyMGRhcmslMjBjaW5lbWF0aWMlMjBuaWdodHxlbnwwfHx8fDE3NzE4MjI5Mzh8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing',
    description: 'Production-integrated storage for raw materials and finished goods.',
    image: 'https://images.pexels.com/photos/4170172/pexels-photo-4170172.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'aerospace',
    name: 'Aerospace / Aviation',
    description: 'Specialized storage for aerospace components and MRO operations.',
    image: 'https://images.unsplash.com/photo-1770119074920-3c5603188095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwcmFja2luZyUyMHN5c3RlbSUyMHN0ZWVsJTIwbWV6emFuaW5lJTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3NzE4MjI5NDB8MA&ixlib=rb-4.1.0&q=85',
  },
];

export default function Industries() {
  return (
    <div className="bg-[#0a1628] pt-20" data-testid="industries-page">
      {/* Hero Section */}
      <section className="py-24 md:py-32 relative overflow-hidden">
        <div className="absolute inset-0 tech-grid-bg opacity-50" />
        <div className="container-custom relative z-10">
          <div className="max-w-4xl">
            <span className="font-mono text-xs text-[#E63946] uppercase tracking-widest mb-4 block">
              Industry Verticals
            </span>
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase leading-[0.9] tracking-tighter mb-6">
              Solutions for <span className="text-[#E63946]">Every Industry</span>
            </h1>
            <p className="text-gray-400 text-lg md:text-xl leading-relaxed max-w-3xl">
              We understand that each industry has unique storage challenges. Our solutions are tailored to meet the specific requirements of your sector.
            </p>
          </div>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-24 md:py-32 bg-[#0f1e32]" data-testid="industries-grid">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industries.map((industry, index) => (
              <Link
                key={industry.id}
                to={`/industries/${industry.id}`}
                className="group"
                data-testid={`industry-card-${industry.id}`}
              >
                <div className="industry-card relative h-80 overflow-hidden border border-white/10 hover:border-[#E63946]/50 transition-colors">
                  {/* Background Image */}
                  <img
                    src={industry.image}
                    alt={industry.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />

                  {/* Content */}
                  <div className="industry-card-content absolute inset-0 flex flex-col justify-end p-6">
                    <div className="font-mono text-sm text-[#E63946] mb-2">0{index + 1}</div>
                    <h3 className="font-heading text-xl font-bold text-white uppercase mb-2 group-hover:text-[#E63946] transition-colors">
                      {industry.name}
                    </h3>
                    <p className="text-gray-400 text-sm mb-4">
                      {industry.description}
                    </p>
                    <div className="flex items-center text-[#E63946] text-sm font-medium group-hover:text-[#E63946] transition-colors">
                      Learn More <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32">
        <div className="container-custom">
          <div className="industrial-card gold-corners bg-[#0f1e32] border border-[#E63946]/30 p-12 md:p-16 text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white uppercase tracking-tight mb-6">
              Don't See Your Industry?
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-10">
              We work with businesses across all sectors. Contact us to discuss how we can create a customized storage solution for your specific industry needs.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/get-quote" data-testid="industries-get-quote">
                <Button className="btn-gold clip-slant h-14 px-10 text-base">
                  Get a Quote <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button className="btn-secondary h-14 px-10 text-base">
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
